var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 5.68698L5.49908 15.7779",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9926 19.5022C4.6045 19.906 4.41045 20.1079 4.18364 20.1865C3.98413 20.2558 3.76782 20.2601 3.56573 20.1988C3.33597 20.1291 3.13408 19.9351 2.73031 19.547L2.15354 18.9926C1.74976 18.6045 1.54787 18.4104 1.46918 18.1836C1.39996 17.9841 1.39567 17.7678 1.45694 17.5657C1.5266 17.336 1.72065 17.1341 2.10875 16.7303L2.66313 16.1535C3.05123 15.7498 3.24528 15.5479 3.47209 15.4692C3.6716 15.3999 3.88791 15.3957 4.09 15.4569C4.31976 15.5266 4.52165 15.7206 4.92542 16.1087L5.50219 16.6631C5.90597 17.0512 6.10786 17.2453 6.18656 17.4721C6.25578 17.6716 6.26006 17.8879 6.19879 18.09C6.12913 18.3197 5.93508 18.5216 5.54698 18.9254L4.9926 19.5022Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9926 5.50219C17.6045 5.90597 17.4105 6.10786 17.1836 6.18655C16.9841 6.25577 16.7678 6.26005 16.5657 6.19878C16.336 6.12913 16.1341 5.93508 15.7303 5.54698L15.1535 4.9926C14.7498 4.6045 14.5479 4.41045 14.4692 4.18363C14.4 3.98412 14.3957 3.76782 14.4569 3.56572C14.5266 3.33597 14.7206 3.13408 15.1087 2.7303L15.6631 2.15353C16.0512 1.74975 16.2453 1.54786 16.4721 1.46917C16.6716 1.39995 16.8879 1.39567 17.09 1.45694C17.3198 1.52659 17.5216 1.72064 17.9254 2.10874L18.5022 2.66312C18.906 3.05122 19.1079 3.24527 19.1866 3.47208C19.2558 3.6716 19.2601 3.8879 19.1988 4.09C19.1291 4.31975 18.9351 4.52164 18.547 4.92542L17.9926 5.50219Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.28d927e9546e4a17fa088a7c31a77b5e.svg";
export { ForwardRef as ReactComponent };